import NotImplementedError from '../../errors/NotImplementedError';

export default class Channel {

    bind(eventName, onMessage) { // eslint-disable-line
        throw new NotImplementedError('bind');
    }

    unbind(eventName, callback) { // eslint-disable-line
        throw new NotImplementedError('unbind');
    }
}
